<fisico-header></fisico-header>

<main id="main" class="vagas container-fluid">
  <section id="vagas" class="row justify-content-center">
    <div class="col-12 col-md-11 mt-5">
      <div class="row mt-5">
        <div class="col-12 col-md-3">
          <h4 class="featuredText">Filtre sua busca</h4>
          <div class="form-group">
            <input
              type="text"
              [(ngModel)]="inputTituloVaga"
              (ngModelChange)="filtrarTituloVaga($event)"
              placeholder="Digite o título da vaga"
              class="form-control border-input inputFiltro"
            />
          </div>
          <div class="form-group custom-dropdown">
            <select
              class="form-control"
              [(ngModel)]="selectEmp"
              minlength="2"
              (change)="filtrarEmp()"
            >
              <option value="p">Selecione uma empresa</option>
              <option
                *ngFor="let emp of empresasFiltradas"
                value="{{ emp.EmpresaId }}"
              >
                <span>{{ emp.Nome }}</span>
              </option>
            </select>
          </div>
          <div class="form-group custom-dropdown">
            <select
              class="form-control"
              [(ngModel)]="selectEstado"
              minlength="2"
              (change)="filtrarEst()"
            >
              <option value="p">Selecione uma região</option>
              <option
                *ngFor="let reg of regioesFiltradas"
                value="{{ reg.estado }}"
              >
                {{ reg.estado }}
              </option>
            </select>
          </div>
          <div class="form-group custom-dropdown">
            <select
              class="form-control"
              [(ngModel)]="selectCidade"
              minlength="2"
              (change)="filtrarCidade()"
            >
              <option value="p">Selecione uma cidade</option>
              <option
                *ngFor="let cidade of cidadesFiltradas"
                value="{{ cidade }}"
              >
                {{ cidade }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <button class="vagasParceirosBtn" (click)="switchToParceiros()">
              Vagas Parceiros
            </button>
          </div>
        </div>
        <div class="col-12 col-md-9">
          <div class="row">
            <div class="col-10 col-md-8">
              <input
                [(ngModel)]="filtro"
                (input)="filtrar()"
                type="text"
                class="form-control border-input inputFiltro"
                placeholder="Que tipo de vaga você procura?"
              />
            </div>
            <div class="col-2 col-md-4">
              <img
                (click)="list()"
                src="assets/img/list.png"
                class="icon-list"
              />
              <img
                (click)="grid()"
                src="assets/img/grid.png"
                class="icon-list"
              />
            </div>
          </div>
          <div style="width: 100%; text-align: center">
            <div style="margin-top: 12%" class="lds-ring" *ngIf="load">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div *ngIf="!load" class="secao-vaga" (scroll)="onScroll($event)">
            <!-- GRID -->
            <div *ngIf="!lista" class="py-3">
              <div
                *ngFor="let vaga of vagas"
                class="col-12 col-sm-6 col-md-6 col-lg-4"
                style="display: inline-block"
                data-aos="fade-up"
              >
                <app-card-vaga
                  [titulo]="vaga.Nome"
                  [urlImagem]="vaga.Logo"
                  [localVaga]="vaga.Cidade + ', ' + vaga.UF"
                  [descricao]="'Veja mais'"
                  [urlVaga]="vaga.UrlVaga"
                  [urlLanding]="vaga.UrlLanding"
                  [empresa]="vaga.Empresa"
                >
                </app-card-vaga>
              </div>
            </div>
            <!-- LIST -->
            <div *ngIf="lista" class="listaDiv">
              <!-- VAGA -->
              <div
                *ngFor="let vaga of vagas"
                class="row border-bottom border-dark py-3 mb-3"
                data-aos="fade-up"
              >
                <div
                  class="col-12 col-md-2 bg-white d-flex justify-content-center align-items-center"
                >
                  <div class="py-2">
                    <a href="{{ vaga.UrlVaga }}" target="_blank">
                      <img class="img-fluid image" src="{{ vaga.Logo }}" />
                    </a>
                  </div>
                </div>
                <div class="col-12 col-md-10">
                  <h2 class="mt-2">
                    <a href="{{ vaga.UrlVaga }}" target="_blank">
                      {{ vaga?.Nome }}
                    </a>
                    <br />
                    <small class="text-info">
                      {{ vaga?.Empresa }} - {{ vaga?.Cidade }}
                    </small>
                  </h2>
                  <p>
                    {{ vaga?.DescricaoVaga }}
                  </p>
                  <p class="text-right">
                    <a
                      href="{{ vaga.UrlVaga }}"
                      target="_blank"
                      class="btn btn-block vagasVerMaisBtn"
                    >
                      Veja mais
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<fisico-footer></fisico-footer>
